'use client';
import { Button, Flex, Text, useDisclosure } from '@chakra-ui/react';
import NextLink from 'next/link';
import HelpModal from '@/components/layout/HelpModal';

export default function NotFound() {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Flex
      pb={{
        base: '60px',
        md: '0px',
      }}
      data-id="not-found"
      justifyContent={'center'}
      alignItems={'center'}
      overflow="auto"
      h={{ base: 'calc(100vh - 90px)', md: 'calc(100vh - 80px)' }}
    >
      <Flex
        direction={'column'}
        gap={3}
        px={8}
        textAlign={'center'}
        alignItems={'center'}
        justifyItems={'center'}
      >
        <Text pt={8}>We couldn't find what you were looking for.</Text>
        <Button
          my={5}
          variant="outline"
          colorScheme="dmOrange"
          size="lg"
          w={'250px'}
          onClick={onOpen}
        >
          Need help booking?
        </Button>

        <Button colorScheme="dmOrange" size="lg" minW={'250px'} as={NextLink} href="/">
          Start New Search
        </Button>
      </Flex>

      <HelpModal isOpen={isOpen} onClose={onClose} />
    </Flex>
  );
}
